import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './FandOPutCallRatio.css';
import { format, parseISO } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'

function FandOPutCallRatio() {
    const [data, setData] = useState([]);
    const [dataSym, setDataSym] = useState([]);
    const [dataExp, setDataExp] = useState([]);
    const [optBtn, setOpteBtn] = useState("Vol");
    const [expDate, setExpDate] = useState("-");
    const [symbol, setSymbol] = useState("-");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let navigate = useNavigate();
    let getData, getDataSym, getDataExp;

    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "Putcallratio";
        fetch(`${getUrl}/${optBtn}/${expDate}/${symbol}/8`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                //console.log(getData, "getData")
            })
            .catch((error) => {
            });
    }, [optBtn, expDate, symbol]);

    const moreContent = () => {
        navigate("/Futures-And-Options/Put-Call-Ratio")
    }

    useEffect(() => {
        const getUrl = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrl}/Sym/-`)
            .then((response) => response.json())
            .then((dataS) => {
                getDataSym = dataS.data;
                setDataSym(getDataSym);
                //console.log("data:", getDataSym);
            })
            .catch((error) => {
                // console.log("not found the api");
            });
        const getUrlExp = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrlExp}/OPT/${symbol}`)
            .then((response) => response.json())
            .then((dataE) => {
                getDataExp = dataE.data;
                setDataExp(getDataExp);
                // console.log("data:", getDataExp);
            })
            .catch((error) => {
                // console.log("not found the api");
            });
    }, [symbol]);

    return (
        <>
            <div className='market-inner-common ipo-head'>
                <div className='market-header'>
                    <h4>Put Call Ratio</h4>
                    <span className="moreContent" onClick={moreContent}>See More</span>
                </div>
                <Container className="add-border table-box">
                    <div className=''>
                        <div className="dropdowndiv">
                            <div className='put-call-toggle'>
                                <button value="Vol" className={(optBtn === "Vol") ? "active" : ''} onClick={(event) => { setOpteBtn(event.target.value) }}>Volume</button>
                                <button value="OI" className={(optBtn === "OI") ? "active" : ''} onClick={(event) => { setOpteBtn(event.target.value) }}>Open Interest</button>
                            </div>
                            <div className='put-option'>
                                <div className='put-call-selectI'>
                                    <select onChange={(event) => { setSymbol(event.target.value) }}>
                                        <option value="-">Select Symbol</option>
                                        {dataSym && dataSym.map(({ symbol }) => (
                                            <option value={symbol.trim()}>{symbol}</option>
                                        )
                                        )}
                                    </select>
                                </div>
                                <div className='put-call-select'>
                                    <select onChange={(event) => { setExpDate(event.target.value) }}>
                                        <option value="-">Select Expiry Date</option>
                                        {dataExp && dataExp.map(({ ExpiryDateText }) => (
                                            <option value={ExpiryDateText.split(' ').join('-')}>{ExpiryDateText.split(' ').join('-')}</option>
                                        )
                                        )}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='gainer-table table-responsivePut'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th className='text-left'>Symbol</th>
                                        <th className='text-right'>Expiry Date</th>
                                        <th className='text-right'>Put</th>
                                        <th className='text-right'>Call</th>
                                        <th className='text-right'>Total</th>
                                        <th className='text-right'>Ratio</th>
                                    </tr>
                                </thead>
                                {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> :''}
                                <tbody>
                                    {(data != null) && data.map(
                                        ({ Symbol, expdate, PutQty, PutOI, CallQty, CallOI, TotQty, TotOI, PCRatioQty, PCRatioOI }) => (
                                            <tr>
                                                <td className="text-left">{Symbol}</td>
                                                <td className="text-right"> {(expdate != null) ? format(parseISO(expdate), 'dd-MMM-yyyy') : 0}</td>
                                                {(optBtn === "Vol") ? <td className='text-right'>{(PutQty != null) ? PutQty : 0}</td> :
                                                    <td className='text-right'>{(PutOI != null) ? PutOI : 0}</td>}
                                                {(optBtn === "Vol") ? <td className='text-right'>{(CallQty != null) ? CallQty : 0}</td> :
                                                    <td className='text-right'>{(CallOI != null) ? CallOI : 0}</td>}
                                                {(optBtn === "Vol") ? <td className='text-right'>{(TotQty != null) ? TotQty : 0}</td> :
                                                    <td className='text-right'>{(TotOI != null) ? TotOI : 0}</td>}
                                                {(optBtn === "Vol") ? <td className='text-right'>{(PCRatioQty != null) ? PCRatioQty.toFixed(2) : 0}</td> :
                                                    <td className='text-right'>{(PCRatioOI != null) ? PCRatioOI.toFixed(2) : 0}</td>}
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                            {loadingshow ? <div className="textcentervertex">
                                <Vortex
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="vortex-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="vortex-wrapper"
                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }
                        </div>
                    </div>
                </Container >
            </div>
        </>
    );
}

export default FandOPutCallRatio;